import React, { useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, FormControlLabel, Grid, Switch, TextField } from '@mui/material'
import { toast } from 'react-toastify'

import './gestionarCuenta.css'
// import iconUpPhoto from '../contactos/iconUpPhoto.svg'

import { Users } from '../../models/users'
import { DialogPreviewImage } from '../modals/previewImage/DialogPreviewImage'
import { uploadFile } from '../../firebase/config'
import { authUpdatePhoto } from '../../redux/actions/auth'

export const InformacionPersonal = () => {

  const { uid } = useSelector(state => state.auth)
  const [form, setForm] = useState({
    id: uid,
    nombre: '',
    apellidos: '',
    email: '',
    url_foto: '',
    celular: '',
    alias: '',
    alias_mostrar: false
  })

  const getInfo = useCallback(async () => {
    const data = await Users.getOne(uid)
    setForm(data)
  }, [uid])

  useEffect(() => {
    getInfo()
  }, [getInfo])

  return (
    <div className='container'>
      <PersonalInfo
        form={form}
        setForm={setForm}
      />
      <ChangePassword
        uid={uid}
      />
    </div>
  )
}

const PersonalInfo = ({ form, setForm }) => {

  const dispatch = useDispatch()
  const [openFiles, setOpenFiles] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)

  const handleChange = ({ target }) => {
    if (target.type === 'checkbox') {
      setForm({
        ...form,
        [target.name]: target.checked
      })
    } else {
      setForm({
        ...form,
        [target.name]: target.value
      })
    }

  }

  const imageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedImage(e.target.files[0])
      setOpenFiles(true)
    }
  }

  // const handleUpload = () => {
  //   document.getElementById('profile_picture').click()
  // }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (form.nombre === '' || form.nombre === null) {
      toast.warn("Falta completar nombre")
      return false
    }

    if (form.email === '' || form.email === null) {
      toast.warn("Falta completar correo electrónico")
      return false
    }

    let dataForm = form

    if (selectedImage) {
      const fileName = `usuario-${form.id || 0}`
      const path = `foto_usuarios/${fileName}`
      try {
        const urlFoto = await uploadFile(selectedImage, path)
        dataForm.url_foto = urlFoto
        dispatch(authUpdatePhoto(urlFoto))

      } catch (error) {
        console.log(error)
        toast.error("Fallo al guardar foto. Intente nuevamente.")
      }
    }

    await Users.update(dataForm)
    setSelectedImage(null)

    setForm(prev => ({
      ...prev,
      url_foto: dataForm.url_foto,
    }))

  }

  return (

    <div className="p-container-info-personal">

      <div className="row p-contet-title-info-personal">
        <div className="col ">
          <h3 className='text-start p-title-info-personal'>Tus datos personales</h3>
        </div>
      </div>

      <form onSubmit={handleSubmit} className='mt-4'>

        <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>

          {/* <Grid item xs={12}>
            <div className='d-flex justify-content-center align-items-center p-container-foto mb-3'>
              {(!selectedImage & !form.url_foto) ?
                <img
                  src={iconUpPhoto} alt="subir foto"
                  onClick={handleUpload}
                />
                :
                <Avatar
                  alt={form.nombre}
                  src={selectedImage ? URL.createObjectURL(selectedImage) : (form.url_foto ? form.url_foto : iconUpPhoto)}
                  sx={{ width: 100, height: 100 }}
                  onClick={handleUpload}
                />
              }
            </div>
          </Grid> */}

          <input
            style={{ display: 'none' }}
            name="profile_picture"
            id="profile_picture"
            accept="image/*"
            type="file"
            onChange={imageChange}
          />

          {selectedImage && (
            <DialogPreviewImage
              open={openFiles}
              setOpen={setOpenFiles}
              setSelectedImage={setSelectedImage}
              selectedImage={selectedImage}
            />
          )}

          <Grid item xs={12} md={6}>
            <TextField
              label="Nombre"
              name="nombre"
              id="outlined-size-small"
              value={form.nombre || ''}
              size="small"
              fullWidth
              placeholder='Ingrese nombre'
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Apellidos"
              name="apellidos"
              id="outlined-size-small"
              value={form.apellidos || ''}
              size="small"
              fullWidth
              placeholder='Ingrese apellidos'
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <div className='p-input-email'>
              <TextField
                label="Correo electrónico"
                name="email"
                id="outlined-size-small"
                value={form.email || ''}
                size="small"
                fullWidth
                placeholder='Ingrese nombre'
                onChange={handleChange}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Número celular"
              name="celular"
              id="outlined-size-small"
              value={form.celular || ''}
              size="small"
              fullWidth
              placeholder='Ingrese número celular '
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <div className='p-input-alias'>
              <TextField
                label="Alias"
                name="alias"
                id="outlined-size-small"
                value={form.alias || ''}
                size="small"
                fullWidth
                placeholder='Ingrese alias'
                onChange={handleChange}
              />
            </div>
          </Grid>

          {(form?.alias !== '' && form?.alias !== null) ?
            <Grid item xs={12} md={2}>
              <FormControlLabel
                className="ms-2"
                control={
                  <Switch
                    style={{ color: form?.alias_mostrar ? '#8E24AA' : '' }}
                    name="alias_mostrar"
                    checked={form?.alias_mostrar}
                    onChange={handleChange}
                  />
                }
                label="Mostrar en pdf"
              />
            </Grid> : ''
          }

          <Grid item xs={12}>
            <div>
              <Button
                id="id-button-save-ppto"
                style={{ width: '170px' }}
                className='p-btn-primary'
                variant="contained"
                size='medium'
                type='submit'
              >
                Guardar cambios
              </Button>
            </div>
          </Grid>
        </Grid>
      </form>

    </div>

  )
}

const ChangePassword = ({ uid }) => {

  const [error, setError] = useState(null)
  const [form, setForm] = useState({
    id: uid,
    password_actual: '',
    password_new: '',
    password_confirm: '',
  })

  const handleChange = ({ target }) => {
    console.log(target.name, target.value)
    setForm({
      ...form,
      [target.name]: target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    setError(null)

    if (form.password_actual !== '' && form.password_new !== '' && form.password_confirm !== '') {

      if (form.password_new.length < 8) {
        setError(3)
        return false
      }

      if (form.password_new !== form.password_confirm) {
        setError(4)
        return false
      }

      const resultUpdate = await Users.updatePassword(form)

      if (resultUpdate.error === 1) {
        setError(1)
        return false
      }

      if (resultUpdate.error === 2) {
        setError(2)
        return false
      }

      setForm({
        ...form,
        password_actual: '',
        password_new: '',
        password_confirm: '',
      })

    }

  }

  return (

    <div className="p-container-info-personal mt-4">

      <div className="row p-contet-title-info-personal">
        <div className="col ">
          <h3 className='text-start p-title-info-personal'>Contraseña e inicio de sesión</h3>
        </div>
        <div className="col-12 p-text-info-personal">
          <h6>Protege tus datos creando una contraseña que sea compleja y tenga la longitud suficiente. Debe resultarte fácil de recordar pero difícil de adivinar para los demás.</h6>
        </div>
      </div>

      <form onSubmit={handleSubmit} className='mt-4'>

        <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>

          <Grid item xs={12} md={6}>
            <TextField
              id="outlined-password-input"
              label="Contraseña actual"
              name="password_actual"
              type="password"
              size="small"
              fullWidth
              value={form.password_actual}
              autoComplete="current-password"
              onChange={handleChange}
            />

            {error === 1 &&
              <div style={{ color: 'red', fontSize: '13px', margin: '2px' }}>La contraseña actual no es correcta</div>
            }

          </Grid>
          <Grid item xs={12} md={6}></Grid>

          <Grid item xs={12} md={6}>
            <TextField
              id="outlined-password-input"
              label="Nueva contraseña"
              name="password_new"
              type="password"
              size="small"
              fullWidth
              value={form.password_new}
              autoComplete="current-password"
              onChange={handleChange}
            />

            {error === 2 &&
              <div style={{ color: 'red', fontSize: '13px', margin: '2px' }}>La nueva contraseña no puede ser la misma que la contraseña actual</div>
            }

            {error === 3 &&
              <div style={{ color: 'red', fontSize: '13px', margin: '2px' }}>La nueva contraseña debe tener una longitud de al menos 8 caracteres</div>
            }

          </Grid>
          <Grid item xs={12} md={6}><span style={{ fontSize: '14px', color: 'gray' }}>mínimo 8 caracteres</span></Grid>

          <Grid item xs={12} md={6}>
            <TextField
              id="outlined-password-input"
              label="Confirmar nueva contraseña"
              name="password_confirm"
              type="password"
              size="small"
              fullWidth
              value={form.password_confirm}
              autoComplete="current-password"
              onChange={handleChange}
            />

            {error === 4 &&
              <div style={{ color: 'red', fontSize: '13px', margin: '2px' }}>No coincide con la nueva contraseña</div>
            }

          </Grid>
          <Grid item xs={12} md={6}></Grid>

          <Grid item xs={12}>
            <div>
              <Button
                id="id-button-save-ppto"
                style={{ width: '170px' }}
                className='p-btn-primary'
                variant="contained"
                size='medium'
                type='submit'
              >
                Cambiar contraseña
              </Button>
            </div>
          </Grid>

        </Grid>
      </form>

    </div>

  )
}